export default {"src":"/_next/static/media/files-drag.1e39a59f.svg","height":40,"width":41};